"use strict";

const MessageModal = require("../modals/messageModal");
const ApiCalls = require("../apiCalls");

const SignedReport = function () {
  var unloadListeners = function ($container) {
    $container
      .off("click", ".js-upload-signed-report", handleUploadSignedReport)
      .off("click", ".download-signed-report", handleDownloadSignedReport);
  };

  var loadListeners = function ($container) {
    unloadListeners($container);
    $container
      .on("click", ".js-upload-signed-report", handleUploadSignedReport)
      .on("click", ".download-signed-report", handleDownloadSignedReport);
  };

  var handleUploadSignedReport = function () {
    const inspectionId = $(this).data("id");
    var $fileInput = $('<input type="file" accept=".pdf,application/pdf" style="display: none;">');
    $("body").append($fileInput);

    $fileInput.on("change", async function (e) {
      var file = e.target.files[0];
      if (!file) return;

      if (file.type !== "application/pdf") {
        MessageModal.showSimpleWarningModal("Please select a PDF file");
        return;
      }

      var formData = new FormData();
      formData.append("file", file);
      formData.append("id", inspectionId);

      try {
        const response = await ApiCalls.uploadSignedReport(formData);
        if (response) {
          MessageModal.showNoticeMessage("Signed report uploaded successfully");
        }
      } catch (error) {
        MessageModal.showSimpleWarningModal(
          "Failed to upload report: " + (error.responseJSON?.message || "Unknown error"),
        );
      } finally {
        $fileInput.remove();
      }
    });

    $fileInput.click();
  };

  var handleDownloadSignedReport = function () {
    const inspectionId = $(this).data("id");
    ApiCalls.downloadSignedInspectionReport(inspectionId);
  };

  return {
    loadListeners,
    unloadListeners,
  };
};

module.exports = SignedReport();
